Ext.define('SA.AcsTable.TableData', {
    constructor({observable}) {
        this.observable = observable;
        this.promises = {};
        this.results = {};
    },

    async createPromise({censusReleaseYear, edition}) {
        var tables = await SA.Ajax.request({resource: 'acsTables', data: {censusRelease: censusReleaseYear, edition}});

        return tables.map(table => ({id: table.table_id, folderId: table.attribute_tree_id, name: table.table_name}));
    },

    key({censusReleaseYear, edition}) {
        return JSON.stringify({censusReleaseYear, edition});
    },

    async load({censusReleaseYear, edition}) {
        var key = this.key({censusReleaseYear, edition});

        if (this.promises[key]) {
            return;
        }

        var promise = this.promises[key] = this.createPromise({censusReleaseYear, edition});

        this.results[key] = await promise;
        this.observable.fireEvent('results');
    },

    get({censusReleaseYear, edition}) {
        return this.results[this.key({censusReleaseYear, edition})] ?? [];
    }
});